import React, { useState } from 'react';
import { Card, Grid, Typography, Button } from '@material-ui/core';
import { Plus } from 'react-feather';
import {
  GQLDeliveryUnit,
  GQLDeliveryUnitAccessoryInventoryStats,
  GQLParty
} from '@jewelutions/core-crm-server-api-client-domain';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';

interface IProps {
  party: GQLParty;
  accessoryId: string;
  deliveryUnit: GQLDeliveryUnit;
}

const AccessoryInventoryStatsWidget: React.FC<IProps> = ({ party, accessoryId, deliveryUnit }: IProps) => {
  const [stats, setStats] = useState((undefined as unknown) as GQLDeliveryUnitAccessoryInventoryStats);
  GQLOperationBuilder.deliveryUnit.getDeliveryUnitAccessoryInventoryStats(
    { producerPartyId: party.id, deliveryUnitId: deliveryUnit.id, accessoryId: accessoryId },
    {
      onCompleted: (data: any) => {
        setStats(GQLOperationBuilder.deliveryUnit.accessoryInventoryStatsFromResponse(data));
      }
    }
  );

  const [
    updateMissingAccessoryInventories
  ] = GQLOperationBuilder.deliveryUnit.createMissingAccessoryInventorys();
  return (
    <Grid container direction="row">
      <Grid item md={4} style={{ marginBottom: '8px' }}>
        <Card style={{ padding: '8px' }}>
          <Typography variant={'h6'}>{deliveryUnit.name}</Typography>
          <div style={{ display: 'inline-flex', flexDirection: 'column' }}>
            <span>
              Accessory Inventories{' '}
              <strong>
                {stats?.existingAccessoryInventoryCount}/{stats?.maximumAccessoryInventoryCount}
              </strong>
            </span>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              disabled={stats?.existingAccessoryInventoryCount === stats?.maximumAccessoryInventoryCount}
              onClick={() => {
                updateMissingAccessoryInventories({
                  variables: { partyId: party.id, deliveryUnitId: deliveryUnit.id, accessoryId: accessoryId }
                });
              }}
            >
              <Plus />
              <span style={{ marginLeft: '4px' }}>Add all missing</span>
            </Button>
          </div>
        </Card>
      </Grid>
    </Grid>
  );
};

export default AccessoryInventoryStatsWidget;
